<!--this textarea version is kept for the moment, is no need, will be removed in near future-->
<div *ngIf="!isButton">
    <div class="wrapper mb-4">
        <div class="link p-2">
            {{ shareLink }}
        </div>
        <a
            href="#"
            (click)="copyLink('hidden-link'); $event.preventDefault()"
            class="copy-link-button d-flex align-items-center justify-content-center text-decoration-none"
            >Copy link</a
        >
    </div>
    <span *ngIf="isCopied" class="font-weight-bold">Link copied to your clipboard</span>
</div>

<!--new copy button feature implemented, can be triggered with isButton boolean-->
<div *ngIf="isButton" class="wrapper-button">
    <div class="share-options mt-6">
        <span class="share-link">
            <label class="font-weight-bold mb-2">{{ label }}</label>
            <div
                class="copy-link d-flex flex-row flex-nowrap justify-content-start align-items-center"
            >
                <button
                    (click)="copyLink('hidden-link')"
                    class="btn btn-primary font-weight-bold d-flex flex-row flex-wrap align-items-center"
                >
                    <i class="fa-link fa-lg fas"></i>Copy Link
                </button>
                <span *ngIf="isCopied" class="ml-4">Link copied to your clipboard</span>
            </div>
        </span>
    </div>
</div>
